import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdfIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 22 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 0.5H13.5C13.5834 0.5 13.6636 0.532868 13.7227 0.591797L21.0078 7.87695C21.0668 7.9359 21.0995 8.01626 21.0996 8.09961V23C21.0996 24.933 19.5326 26.5 17.5996 26.5H4C2.067 26.5 0.5 24.933 0.5 23V4C0.5 2.067 2.067 0.5 4 0.5Z",
			fill: "url(#paint0_linear_10430_48211)",
			stroke: "#D5D7DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.34206 21.825C6.11794 21.825 5.94986 21.7693 5.78177 21.7136C5.16545 21.3793 5.10942 20.8779 5.22148 20.4879C5.4456 19.8193 6.67823 18.9836 8.30307 18.2593C9.03145 16.9221 9.59174 15.5293 9.92791 14.3593C9.36762 13.3007 9.08748 12.2979 9.08748 11.5736C9.08748 11.1836 9.19953 10.8493 9.36762 10.5707C9.59174 10.2921 9.92791 10.125 10.3761 10.125C10.8804 10.125 11.2726 10.4036 11.4407 10.905C11.7208 11.5736 11.5527 12.7993 11.1605 14.1921C11.7208 15.1393 12.3932 16.0307 13.1216 16.6993C14.1861 16.4764 15.1386 16.365 15.7549 16.4764C16.8195 16.6436 16.9875 17.3679 16.9875 17.6464C16.9875 18.8164 15.7549 18.8164 15.3067 18.8164C14.4662 18.8164 13.6258 18.4821 12.8974 17.8693C11.5527 18.2036 10.2081 18.6493 9.1435 19.1507C8.58322 20.0979 8.02293 20.8779 7.51867 21.3236C7.01441 21.7136 6.6222 21.825 6.34206 21.825ZM7.01441 20.2093C6.73426 20.3764 6.51015 20.5436 6.39809 20.7107C6.51015 20.655 6.73426 20.5436 7.01441 20.2093ZM14.6343 17.5907C14.8585 17.6464 15.0826 17.7021 15.3067 17.7021C15.6429 17.7021 15.8109 17.6464 15.867 17.6464C15.8109 17.5907 15.4187 17.4793 14.6343 17.5907ZM10.7123 15.585C10.4882 16.2536 10.152 16.9779 9.87188 17.6464C10.5442 17.4236 11.2166 17.2007 11.8889 17.0336C11.4407 16.5879 11.0485 16.0864 10.7123 15.585ZM10.3761 11.2393C10.3201 11.2393 10.3201 11.2393 10.3201 11.2393C10.2641 11.295 10.2081 11.685 10.4322 12.5207C10.4882 11.8521 10.4882 11.3507 10.3761 11.2393Z",
			fill: "#535862"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 0.337891V4.10039C13.5 6.30953 15.2909 8.10039 17.5 8.10039H21.2625",
			stroke: "#D5D7DA"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10430_48211",
			x1: 10.8,
			y1: 0,
			x2: 10.8,
			y2: 27,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F5F5F5"
			})]
		}) })
	]
});
export default SvgPdfIcon;
